<template>
  <div>
    <h3 class="productblock-title">Bestsellers</h3>
    <div class="row bestseller-grid product-grid">
      <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12 product-grid-item">
        <div class="product-thumb transition">
          <div class="image product-imageblock">
            <a href="#">
              <img
                src="@/assets/image/product/2product50x59.jpg"
                alt="iPhone"
                title="iPhone"
                class="img-responsive"
              />
            </a>
            <div class="button-group">
              <button
                type="button"
                class="wishlist"
                data-toggle="tooltip"
                title="Add to Wish List"
              >
                <i class="fa fa-heart-o"></i>
              </button>
              <button type="button" class="addtocart-btn">
                Add to Cart
              </button>
              <button
                type="button"
                class="compare"
                data-toggle="tooltip"
                title="Compare this Product"
              >
                <i class="fa fa-exchange"></i>
              </button>
            </div>
          </div>
          <div class="caption product-detail">
            <h4 class="product-name">
              <a href="product.html" title="iPhone"> iPhone </a>
            </h4>
            <p class="price product-price">
              <span class="price-new">$254.00</span>
              <span class="price-old">$272.00</span>
              <span class="price-tax">Ex Tax: $210.00</span>
            </p>
          </div>
          <div class="button-group">
            <button
              type="button"
              class="wishlist"
              data-toggle="tooltip"
              title="Add to Wish List"
            >
              <i class="fa fa-heart-o"></i>
            </button>
            <button type="button" class="addtocart-btn">
              Add to Cart
            </button>
            <button
              type="button"
              class="compare"
              data-toggle="tooltip"
              title="Compare this Product"
            >
              <i class="fa fa-exchange"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12 product-grid-item">
        <div class="product-thumb transition">
          <div class="image product-imageblock">
            <a href="#">
              <img
                src="@/assets/image/product/3product50x59.jpg"
                alt="iPhone"
                title="iPhone"
                class="img-responsive"
              />
            </a>
            <div class="button-group">
              <button
                type="button"
                class="wishlist"
                data-toggle="tooltip"
                title="Add to Wish List"
              >
                <i class="fa fa-heart-o"></i>
              </button>
              <button type="button" class="addtocart-btn">
                Add to Cart
              </button>
              <button
                type="button"
                class="compare"
                data-toggle="tooltip"
                title="Compare this Product"
              >
                <i class="fa fa-exchange"></i>
              </button>
            </div>
          </div>
          <div class="caption product-detail">
            <h4 class="product-name">
              <a href="product.html" title="iPhone"> iPhone </a>
            </h4>
            <p class="price product-price">
              <span class="price-new">$254.00</span>
              <span class="price-old">$272.00</span>
              <span class="price-tax">Ex Tax: $210.00</span>
            </p>
          </div>
          <div class="button-group">
            <button
              type="button"
              class="wishlist"
              data-toggle="tooltip"
              title="Add to Wish List"
            >
              <i class="fa fa-heart-o"></i>
            </button>
            <button type="button" class="addtocart-btn">
              Add to Cart
            </button>
            <button
              type="button"
              class="compare"
              data-toggle="tooltip"
              title="Compare this Product"
            >
              <i class="fa fa-exchange"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12 product-grid-item">
        <div class="product-thumb transition">
          <div class="image product-imageblock">
            <a href="#">
              <img
                src="@/assets/image/product/4product50x59.jpg"
                alt="iPhone"
                title="iPhone"
                class="img-responsive"
              />
            </a>
            <div class="button-group">
              <button
                type="button"
                class="wishlist"
                data-toggle="tooltip"
                title="Add to Wish List"
              >
                <i class="fa fa-heart-o"></i>
              </button>
              <button type="button" class="addtocart-btn">
                Add to Cart
              </button>
              <button
                type="button"
                class="compare"
                data-toggle="tooltip"
                title="Compare this Product"
              >
                <i class="fa fa-exchange"></i>
              </button>
            </div>
          </div>
          <div class="caption product-detail">
            <h4 class="product-name">
              <a href="product.html" title="iPhone"> iPhone </a>
            </h4>
            <p class="price product-price">
              <span class="price-new">$254.00</span>
              <span class="price-old">$272.00</span>
              <span class="price-tax">Ex Tax: $210.00</span>
            </p>
          </div>
          <div class="button-group">
            <button
              type="button"
              class="wishlist"
              data-toggle="tooltip"
              title="Add to Wish List"
            >
              <i class="fa fa-heart-o"></i>
            </button>
            <button type="button" class="addtocart-btn">
              Add to Cart
            </button>
            <button
              type="button"
              class="compare"
              data-toggle="tooltip"
              title="Compare this Product"
            >
              <i class="fa fa-exchange"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BestSellers",
  data() {
    return {};
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/product/BestSellers.vue